import React from 'react'

import './styles.css'

export default class Picture extends React.Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props)
    this.pic = React.createRef();

    this.state = {
      source : this.props.source,
    }
  }

  componentDidMount () {
  }

  // COMPUTED

  // RENDER
  render() {
    return (
      <img 
        className="responsive-pic" 
        src={this.state.source} 
        alt=""
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Photographer/Picture/index.jsx